import { useState } from 'react';
import { InputsContext, initialStandardInputsContext, type StandardCalculatorInputs } from './inputs-context';

interface InputsContextProviderProps {
    children: React.ReactNode;
}

export const InputsContextProvider = ({ children }: InputsContextProviderProps) => {
    const [calcInputs, setCalcInputs] = useState<StandardCalculatorInputs>(initialStandardInputsContext.calcInputs);
    const [compareWithSavingsAccount, setCompareWithSavingsAccount] = useState(
        initialStandardInputsContext.compareWithSavingsAccount,
    );

    return (
        <InputsContext.Provider
            value={{
                calcInputs,
                compareWithSavingsAccount,
                setCalcInputs,
                setCompareWithSavingsAccount,
            }}
        >
            {children}
        </InputsContext.Provider>
    );
};
